module.exports = __webpack_public_path__ + "static/media/18import-44.70d9e93e.xlsx";